import { FC } from 'react'
import { Control, Controller } from 'react-hook-form'

import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { Card } from '@/components/ui'
import { cn } from '@/lib/utils'

interface CheckboxGroupFieldProps {
  name: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>
  label: string
  options: { value: string; label: string }[]
}

export const CheckboxGroupField: FC<CheckboxGroupFieldProps> = ({
  name,
  control,
  label,
  options,
}) => (
  <Card className="flex w-full flex-col gap-2 bg-monochrome-3-60 p-[15px]">
    <Label className="!text-title-xs text-monochrome-1 mb-5">{label}</Label>

    <Controller
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      name={name as any}
      control={control}
      render={({ field, fieldState }) => (
        <>
          <div className="grid grid-cols-4 gap-4 w-full">
            {options.map((option, index) => (
              <div
                key={option.value}
                className={cn(
                  'flex items-center gap-2 border-l border-monochrome-120 pl-4',
                  (index === 0 || index % 4 === 0) && 'border-l-0 pl-0',
                )}
              >
                <Checkbox
                  id={`${name}-${option.value}`}
                  checked={(field.value as string[])?.includes(option.value)}
                  onCheckedChange={(checked) => {
                    const current = (field.value as string[]) || []
                    field.onChange(
                      checked
                        ? [...current, option.value]
                        : current.filter((v: string) => v !== option.value),
                    )
                  }}
                />
                <label
                  htmlFor={`${name}-${option.value}`}
                  className="text-body-medium text-monochrome-1 cursor-pointer"
                >
                  {option.label}
                </label>
              </div>
            ))}
          </div>
          {fieldState.error?.message && (
            <p className="text-sm text-red-500 mt-1">
              {fieldState.error.message}
            </p>
          )}
        </>
      )}
    />
  </Card>
)
